// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c3Lu7rSauNmdOy {
  z-index: 10;
  margin: var(--ds-space-0, 0) var(--ds-space-025, 2px);
  border-radius: 16px;
  background-color: var(--ds-surface-raised, #ffffff);
}
.c3Lu7rSauNmdOy:hover {
  background-color: var(--ds-surface-raised-hovered, #f1f2f4);
}
.c3Lu7rSauNmdOy:active {
  background-color: var(--ds-surface-raised-pressed, #dcdfe4);
}
.c3Lu7rSauNmdOy > span > svg {
  width: 14px;
  height: 14px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"deleteButton": `c3Lu7rSauNmdOy`
};
export default ___CSS_LOADER_EXPORT___;
